import { AddPromotion } from '~/features/Promotion/AddPromotion'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { title: 'Акции', link: '/promotion' },
  { title: 'Создание акции' },
]

export const AddPromotionPage = () => {
  return (
    <PageContainer title='Создание акции'>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>Новая акция</PageTitle>
      </Container>
      <AddPromotion />
    </PageContainer>
  )
}
